export var VendorTypeEnum;
(function (VendorTypeEnum) {
    VendorTypeEnum["ExistingVendor"] = "existing_vendor";
    VendorTypeEnum["NewVendorForRightway"] = "new_vendor_for_rightway";
})(VendorTypeEnum || (VendorTypeEnum = {}));
export var vendorTypeOptions = [
    { label: 'Existing Vendor', value: VendorTypeEnum.ExistingVendor },
    {
        label: 'New Vendor for Rightway',
        value: VendorTypeEnum.NewVendorForRightway
    }
];
var RequestSourceEnum;
(function (RequestSourceEnum) {
    RequestSourceEnum["NewImplementation"] = "new_implementation";
    RequestSourceEnum["RxdataexchangeInbox"] = "rxdataexchange_inbox";
    RequestSourceEnum["VendorRequest"] = "vendor_request";
    RequestSourceEnum["AccountManagementRequest"] = "account_management_request";
})(RequestSourceEnum || (RequestSourceEnum = {}));
export var requestSourceOptions = [
    { label: 'New Implementation', value: RequestSourceEnum.NewImplementation },
    {
        label: 'Rxdataexchange Inbox',
        value: RequestSourceEnum.RxdataexchangeInbox
    },
    { label: 'Vendor Request', value: RequestSourceEnum.VendorRequest },
    {
        label: 'Account Management Request',
        value: RequestSourceEnum.AccountManagementRequest
    }
];
var RequestTypeEnum;
(function (RequestTypeEnum) {
    RequestTypeEnum["Update"] = "update";
    RequestTypeEnum["Issue"] = "issue";
})(RequestTypeEnum || (RequestTypeEnum = {}));
export var requestTypeOptions = [
    { label: 'Update', value: RequestTypeEnum.Update },
    { label: 'Issue', value: RequestTypeEnum.Issue }
];
var SFTPStatusEnum;
(function (SFTPStatusEnum) {
    SFTPStatusEnum["NotRequired"] = "not_required";
    SFTPStatusEnum["Existing"] = "existing";
    SFTPStatusEnum["NewRequired"] = "new_required";
    SFTPStatusEnum["Established"] = "established";
})(SFTPStatusEnum || (SFTPStatusEnum = {}));
export var sftpStatusOptions = [
    { label: 'Not Required', value: SFTPStatusEnum.NotRequired },
    { label: 'Existing', value: SFTPStatusEnum.Existing },
    { label: 'New Required', value: SFTPStatusEnum.NewRequired },
    { label: 'Established', value: SFTPStatusEnum.Established }
];
var ClaimFileProcessingAttachmentsEnum;
(function (ClaimFileProcessingAttachmentsEnum) {
    ClaimFileProcessingAttachmentsEnum["ClaimsExtractIntakeForm"] = "claims_extract_intake_form";
    ClaimFileProcessingAttachmentsEnum["FileLayout"] = "file_layout";
    ClaimFileProcessingAttachmentsEnum["VendorCorrespondence"] = "vendor_correspondence";
})(ClaimFileProcessingAttachmentsEnum || (ClaimFileProcessingAttachmentsEnum = {}));
export var claimFileProcessingAttachmentsOptions = [
    {
        label: 'Claims Extract Intake Form',
        value: ClaimFileProcessingAttachmentsEnum.ClaimsExtractIntakeForm
    },
    {
        label: 'File Layout',
        value: ClaimFileProcessingAttachmentsEnum.FileLayout
    },
    {
        label: 'Vendor Correspondence',
        value: ClaimFileProcessingAttachmentsEnum.VendorCorrespondence
    }
];
